import { memo } from "react";

import { BTLink, BTLinkRelative } from "commonComponents/btWrappers/BTLink/BTLink";
import { type IGridCellRendererParams } from "commonComponents/utilities/AgGridReact/AgGridReact.types";

export interface IColumnUrlProps extends IGridCellRendererParams {
    linkTo: string;
    linkText: string;
    useRelativeLink?: boolean; // use relative link for internal navigation such as modals
}

function columnUrlInternal(props: IColumnUrlProps) {
    if (props.useRelativeLink) {
        return (
            <BTLinkRelative to={props.linkTo} useAutoSPARouting>
                {props.linkText}
            </BTLinkRelative>
        );
    } else {
        return (
            <BTLink to={props.linkTo} useAutoSPARouting>
                {props.linkText}
            </BTLink>
        );
    }
}

export const columnUrl = memo(columnUrlInternal);
